var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[(_vm.references.length > 0)?_c('custom-table',{attrs:{"headings":_vm.getHeadings}},_vm._l((_vm.references),function(reference){return _c('product-sales-stats-details-item',{key:reference.id,attrs:{"reference":reference}})}),1):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }